export type ReportsFoldersQueryParams = {
  entityId?: number;
  sort?: Record<string, string> | null;
};

export const reportsFoldersQueryKeys = {
  all: ['reportsFolders'] as const,
  withQueryParams: ({ entityId, sort }: ReportsFoldersQueryParams) =>
    [...reportsFoldersQueryKeys.all, entityId, sort] as const
};
